import React from "react";
import css from "./popUp.module.css";

const PopUpEur = React.forwardRef((props, ref) => {
  return (
    <div className={css.dropPopWrap} ref={ref}>
      <p className={css.mainPopP}>
        Відтепер наші видання можна замовити з швидкою доставкою по Європі.
        <br />
        Офіційній дистриб'ютор Видавництво Час Майстрів" у ЄС (Польща м.
        Краків): Міла Радченко <a href="tel:+48790820066">
          +48 790 820 066
        </a>{" "}
        <a href="mailto:mila@chasmaistriv.com.ua">mila@chasmaistriv.com.ua</a>{" "}
        реєструєтесь зі статусом "Дропшипінг"; зручний сервіс замовлення на
        сайті в розділі "Прайс-гурт", зручний довіз, звіти.
      </p>
    </div>
  );
});

export default PopUpEur;
